<template>
  <modal
    style=""
    class="manage-plan-modal"
    :active="active"
    @close="handleCloseModal"
  >
    <div slot="title">Manage Plan ({{ activeInvestorReport.plan.code }})</div>
    <form-wizard
      @on-complete="handleSave"
      @on-change="scrollToTop"
      title
      subtitle
      color="#8cc63f"
      finish-button-text="Submit"
      shape="square"
    >
      <tab-content title="Plan Details" icon="ti-list">
        <div
          style="
            display: flex;
            align-items: center;
            margin-top: 10px;
            flex-direction: column;
          "
        >
          <div class="col-12" style="margin-top: 10px; display: flex">
            <div style="padding-left: 0" class="col-6">
              <label>Plan ID</label>
              <input
                class="form-control"
                type="text"
                disabled
                :value="activeInvestorReport.plan.code"
              />
            </div>
            <div style="padding-right: 0" class="col-6">
              <label>Plan Name</label>
              <input
                class="form-control"
                type="text"
                disabled
                :value="activeInvestorReport.plan.name"
              />
            </div>
          </div>
          <!-- <div class="col-12" style="margin-top: 10px">
            <label>Description</label>
            <textarea
              class="form-control"
              type="text"
              required
              v-model="description"
            />
          </div> -->
          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label>Capital (2024)</label>
              <input
                class="form-control"
                disabled
                :value="activeInvestorReport.contract.invested_principal"
              />
            </div>
            <div class="col-6" style="padding-right: 0">
              <label>Net (2024)</label>
              <input class="form-control" disabled :value="contractNet()" />
            </div>
          </div>
          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label>Action:</label>
              <select style="" class="form-control" v-model="type">
                <option
                  v-for="transactionType in transactionTypes"
                  :key="transactionType.name"
                  :value="transactionType.id"
                >
                  {{ transactionType.name }}
                </option>
              </select>
            </div>
            <div class="col-6" style="padding-right: 0">
              <label>Amount</label>
              <input
                class="form-control"
                required
                type="number"
                v-model="amount"
              />
              <span v-if="type == 'withdrawal'" @click="setMax" class="max-text"
                >Profit</span
              >
            </div>
          </div>
          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label>Capital (2025)</label>
              <input
                class="form-control"
                type="text"
                required
                :value="fixNumberView(contract_net)"
                @input="onInput"
              />
            </div>

            <div class="col-6" style="padding-right: 0">
              <label>Payment Type</label>
              <select class="custom-select" v-model="payment_type">
                <option
                  v-for="(type, key) in paymentTypes"
                  :key="key"
                  :value="type.id"
                >
                  {{ type.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </tab-content>
      <tab-content
        title="Bank Details"
        icon="ti-wallet"
        v-if="type == 'withdrawal'"
      >
        <div
          v-if="payment_type == 'banktransfer'"
          style="
            display: flex;
            align-items: center;
            margin-top: 10px;
            flex-direction: column;
          "
        >
          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label for="bankName">Bank Name</label>
              <input
                class="form-control"
                type="text"
                id="bankName"
                v-model="bankDetails.bankName"
                placeholder="Enter recipient's bank name"
                required
              />
            </div>
            <div class="col-6" style="padding-right: 0">
              <label for="bankAddress">Bank Address</label>
              <input
                class="form-control"
                type="text"
                id="bankAddress"
                v-model="bankDetails.bankAddress"
                placeholder="Enter recipient's bank address"
                required
              />
            </div>
          </div>

          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label for="beneficiaryName">Beneficiary Name</label>
              <input
                class="form-control"
                type="text"
                id="beneficiaryName"
                v-model="bankDetails.beneficiaryName"
                placeholder="Enter beneficiary name"
                required
              />
            </div>
            <div class="col-6" style="padding-right: 0">
              <label for="beneficiaryAddress">Beneficiary Address</label>
              <input
                class="form-control"
                type="text"
                id="beneficiaryAddress"
                v-model="bankDetails.beneficiaryAddress"
                placeholder="Enter beneficiary address"
                required
              />
            </div>
          </div>

          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label for="iban">IBAN</label>
              <input
                class="form-control"
                type="text"
                id="iban"
                v-model="bankDetails.iban"
                placeholder="Enter IBAN"
                required
              />
            </div>

            <div class="col-6" style="padding-right: 0">
              <label for="swiftBic">SWIFT Code</label>
              <input
                class="form-control"
                type="text"
                id="swiftBic"
                v-model="bankDetails.swiftBic"
                placeholder="Enter SWIFT/BIC Code"
                required
              />
            </div>
          </div>

          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label for="accountNumber">Account Number</label>
              <input
                class="form-control"
                type="text"
                id="accountNumber"
                v-model="bankDetails.accountNumber"
                placeholder="Enter account number"
                required
              />
            </div>
            <div class="col-6" style="padding-right: 0">
              <label for="accountCurrency">Account Currency</label>
              <input
                class="form-control"
                type="text"
                id="accountCurrency"
                v-model="bankDetails.accountCurrency"
                placeholder="Enter account currency"
                required
              />
            </div>
          </div>
          <div class="col-12" style="margin-top: 10px; display: flex">
            <input
              style="margin-right: 5px"
              type="checkbox"
              v-model="bankDetails.consentSave"
            />
            <label
              style="font-size: 12px; font-weight: bold"
              for="bankDetails.consentSave"
            >
              Save my bank account details for future use.</label
            >
          </div>
        </div>
        <div
          v-else
          style="
            display: flex;
            align-items: center;
            margin-top: 10px;
            flex-direction: column;
          "
        >
          <div class="col-12" style="margin-top: 10px">
            <label for="blockchainDetails.wallet_address"
              >USDT Wallet Address</label
            >
            <input
              class="form-control"
              type="text"
              id="blockchainDetails.wallet_address"
              v-model="blockchainDetails.wallet_address"
              placeholder="Enter wallet number"
              required
            />
          </div>
          <div class="col-12" style="margin-top: 10px; display: flex">
            <input
              style="margin-right: 5px"
              type="checkbox"
              v-model="blockchainDetails.consentSave"
            />
            <label
              style="font-size: 12px; font-weight: bold"
              for="blockchainDetails.consentSave"
            >
              Save my wallet address for future use.</label
            >
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </modal>
</template> 
   <script>
import Spinner from "vue-simple-spinner";
import Modal from "../../../../components/Modal.vue";
import TransactionRequestStorer from "../../../../storers/StoreTransactionRequest";
import { mapState } from "vuex";
import sweetAlert from "sweetalert2";

export default {
  data() {
    return {
      type: "withdrawal",
      amount: 0,
      payment_type: "banktransfer",
      paymentTypes: [
        { id: "banktransfer", name: "Bank Transfer" },
        { id: "blockchain", name: "Blockchain" },
      ],
      contract_net: 0,
      transactionTypes: [
        { id: "deposit", name: "Deposit" },
        { id: "withdrawal", name: "Withdrawal" },
      ],
      bankDetails: {
        bankName: "",
        bankAddress: "",
        beneficiaryName: "",
        beneficiaryAddress: "",
        swiftBic: "",
        iban: "",
        accountNumber: "",
        accountCurrency: "",
        consentSave: true,
      },
      blockchainDetails: {
        wallet_address: "",
        consentSave: true,
      },
    };
  },
  props: {
    netProfit: Number,
    active: Boolean,
    activeInvestorReport: Object,
  },
  components: { Spinner, Modal },
  created: function () {
    this.contract_net =
      this.activeInvestorReport.contract.invested_principal + this.netProfit;
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
    }),
  },
  updated() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      const modalContent = document.querySelector(".modal-body");
      modalContent.scrollTo(0, 0);
    },
    handleCloseModal() {
      this.$emit("closeRequest");
    },
    formValidation(transactionRequest) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";

      if (parseFloat(transactionRequest.amount) <= 0) {
        missingFieldsString += "Amount field should be greater than 0, ";
        result.isValid = false;
      }
      if (transactionRequest.type == "withdrawal") {
        if (transactionRequest.payment_type == "banktransfer") {
          if (!transactionRequest.bankDetails.bankName) {
            missingFieldsString += "Bank name field is required, ";
            result.isValid = false;
          }
          if (!transactionRequest.bankDetails.bankAddress) {
            missingFieldsString += "Bank address field is required, ";
            result.isValid = false;
          }
          if (!transactionRequest.bankDetails.beneficiaryName) {
            missingFieldsString += "Beneficiary name field is required, ";
            result.isValid = false;
          }
          if (!transactionRequest.bankDetails.beneficiaryAddress) {
            missingFieldsString += "Beneficiary address field is required, ";
            result.isValid = false;
          }
          if (!transactionRequest.bankDetails.iban) {
            missingFieldsString += "IBAN field is required, ";
            result.isValid = false;
          }
          if (!transactionRequest.bankDetails.swiftBic) {
            missingFieldsString += "SWIFT/BIC code field is required, ";
            result.isValid = false;
          }
          if (!transactionRequest.bankDetails.accountNumber) {
            missingFieldsString += "Account number field is required, ";
            result.isValid = false;
          }
          if (!transactionRequest.bankDetails.accountCurrency) {
            missingFieldsString += "Account currency field is required, ";
            result.isValid = false;
          }
        } else if (transactionRequest.payment_type == "blockchain") {
          if (!transactionRequest.blockchainDetails.wallet_address) {
            missingFieldsString += "Wallet address field is required, ";
            result.isValid = false;
          }
        }
      }

      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    handleSave() {
      let transactionRequestStorer = new TransactionRequestStorer();
      transactionRequestStorer.contract_id =
        this.activeInvestorReport.contract.id;
      transactionRequestStorer.investor_id = this.authUser.userable.id;
      transactionRequestStorer.amount = this.amount;
      transactionRequestStorer.type = this.type;
      transactionRequestStorer.payment_type = this.payment_type;
      transactionRequestStorer.bankDetails = this.bankDetails;
      transactionRequestStorer.blockchainDetails = this.blockchainDetails;
      transactionRequestStorer.payment_type = this.payment_type;
      transactionRequestStorer.status = "pending-review";
      transactionRequestStorer.currency_id =
        this.activeInvestorReport.contract.currency_id;
      const { isValid, message } = this.formValidation(
        transactionRequestStorer
      );
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
          confirmButtonColor: "#d73535",
        });
        return;
      }
      sweetAlert({
        title: "Are you sure?",
        text:
          "Please sign with your full name to confirm plan changes (" +
          this.authUser.userable.first_name +
          " " +
          this.authUser.userable.last_name +
          ")",
        input: "text",
        inputPlaceholder: "Enter your full name here",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.dismiss == "cancel") {
          return;
        }
        if (
          result.value ===
          this.authUser.userable.first_name +
            " " +
            this.authUser.userable.last_name
        ) {
          this.$emit("saveRequest", transactionRequestStorer);
        } else {
          sweetAlert({
            title: "Error",
            text: "Your signature does not match",
            type: "error",
            confirmButtonText: "Return",
            confirmButtonColor: "#d73535",
          });
        }
      });
    },
    setMax() {
      // Sets the input value to the maximum value
      this.amount = this.netProfit;
    },
    contractNet() {
      let net =
        this.activeInvestorReport.contract.invested_principal + this.netProfit;
      return this.fixNumberView(net);
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    calculateContractNet() {
      let net =
        this.activeInvestorReport.contract.invested_principal + this.netProfit;
      if (this.type == "withdrawal") {
        this.contract_net = parseFloat(net) - parseFloat(this.amount);
      } else if (this.type == "deposit") {
        this.contract_net = parseFloat(net) + parseFloat(this.amount);
      } else {
        this.contract_net = parseFloat(net);
      }
    },
    calculateAmount() {
      if (
        this.contract_net >
        this.activeInvestorReport.contract.invested_principal + this.netProfit
      ) {
        this.type = "deposit";
        this.amount =
          this.contract_net -
          (this.activeInvestorReport.contract.invested_principal +
            this.netProfit);
      } else if (
        this.contract_net <=
        this.activeInvestorReport.contract.invested_principal + this.netProfit
      ) {
        this.type = "withdrawal";
        this.amount =
          this.activeInvestorReport.contract.invested_principal +
          this.netProfit -
          this.contract_net;
      }
    },
    onInput(event) {
      let value = event.target.value;

      // Remove any non-numeric characters except for decimal point
      value = value.replace(/[^0-9.]/g, "");

      // Update the numeric model value
      this.contract_net = value === "" ? 0 : parseFloat(value);
    },
  },
  watch: {
    amount() {
      this.calculateContractNet();
    },
    type() {
      this.calculateContractNet();
    },
    contract_net() {
      this.calculateAmount();
    },
  },
};
</script> 
<style>
.max-text {
  position: absolute;
  right: 25px;
  bottom: -5px;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 12px;
  color: #8cc63f;
  font-weight: bold;
}
.max-text:hover {
  color: #0056b3;
}
label {
  margin: 0;
  align-items: center;
  display: flex;
}
input {
  font-size: 16px !important;
}
.form-group {
  display: flex;
  margin: 0;
}
h3 {
  font-size: 1.4rem;
  line-height: 1.4em;
  margin: 0;
  text-align: center;
  font-weight: bold;
}

.wizard-icon {
  color: rgb(140, 198, 63) !important;
}
.active .wizard-icon {
  color: rgb(255, 255, 255) !important;
}
.wizard-icon-circle {
  border-color: rgb(140, 198, 63) !important;
  background-color: #fafaf7 !important;
}
.stepTitle {
  color: rgb(140, 198, 63) !important;
  margin-top: 5px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  padding: 10px;
}
.custom-select {
  background-color: transparent !important;
}
.wizard-btn {
  margin-bottom: 20px !important;
}
.vue-form-wizard.md .wizard-icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 15px;
  font-size: 24px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape {
  width: 80px;
  height: 80px;
  border-radius: 15px;
  padding: 32px;
}
.vue-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 34px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon {
  font-size: 34px;
}
.vue-form-wizard .wizard-header {
  padding: 0 !important;
}
.vue-form-wizard .wizard-card-footer {
  padding: 10px 35px 0 35px !important;
}
.wizard-tab-content {
  padding-top: 0px !important;
}
.manage-plan-modal {
  margin-left: 0 !important;
  margin-top: 5px !important;
  overflow: hidden !important;
  min-height: 535px;
}
.modal-footer {
  display: none !important;
}

.modal-body {
  max-height: 535px !important;
  overflow: hidden !important;
}
.modal-dialog {
  margin-top: 5px;
}
.vue-form-wizard .wizard-btn {
  min-width: 100px;
}

@media (max-width: 767px) {
  .manage-plan-modal {
    margin-top: 60px !important;
  }
  .modal-body {
    max-height: 535px !important;
    overflow: auto !important;
  }
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/modals/manageInvestorPlanModal.vue